import { render, staticRenderFns } from "./SendMessageDetailContent.vue?vue&type=template&id=ceec028a&scoped=true&lang=pug"
import script from "./SendMessageDetailContent.vue?vue&type=script&lang=ts"
export * from "./SendMessageDetailContent.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDetailContent.vue?vue&type=style&index=0&id=ceec028a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec028a",
  null
  
)

export default component.exports